import { useTranslation } from "@equiem/web-ng-lib";
import { Tag } from "@equiem/react-end-user-ui";
import React from "react";
import { DealTag } from "../../store/products/DealTag";
import { getAvailabilityBadge } from "../../store/products/useAvailabilityStatus";
import { SearchNode } from "./SearchEdge";
import { SearchResult } from "./SearchResult";
import { FaStore } from "react-icons/fa";

interface Props {
  product: SearchNode<"DealContentEdge">;
}

export const DealProductSearchResult: React.FC<Props> = ({ product }) => {
  const { t } = useTranslation();

  const badge = getAvailabilityBadge(product.availability?.tagText);

  return (
    <SearchResult
      href="/store/deal/[uuid]"
      as={`/store/deal/${product.uuid}`}
      title={product.name}
      body={product.excerpt}
      imageUrl={product.image ?? undefined}
      imageSuffix={
        <>
          {product.showOverlay ? <DealTag /> : null}
          {badge != null ? (
            <div className="availability-tag" style={{ position: "absolute", top: "4px", right: "4px", zIndex: 1 }}>
              <Tag variant={badge.variant} size="small" emphasis="high" border>{badge.label}</Tag>
            </div>
          ) : null}
        </>
      }
      footer={
        <div className="mt-auto">
          <div className="vendor-name pb-2 d-flex align-items-center">
            <FaStore /> <span className="ml-2">{product.vendor.name}</span>
          </div>
          {product.showOverlay ? t("main.deal") : null}
        </div>
      }
    />
  );
};
